module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"nameTitle":"Heizungstyp","typeTitle":"Typ","sourceTitle":"Wärmequelle","energyCarrierTitle":"Energieträger","gridEfficiencyTitle":"Wärmenetz Effizienz","rhEfficiencyTitle":"Nutzungsgrad Raumwärme","dhwEfficiencyTitle":"Nutzungsgrad Warmwasser","heatpumpGradeTitle":"Gütegrad","duplicateNameErrorMessage":"Name muss innerhalb des Portfolios einzigartig sein."}}')
  delete Component.options._Ctor
}
